import { rem } from "@certn/cascadia";
import { useColors, useMediaQuery, useShadows } from "@certn/cascadia-react";
import { shapes } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

export function useStyles() {
  const { mediaQuery } = useMediaQuery();
  const colors = useColors();
  const shadows = useShadows();

  return {
    container: css(
      mediaQuery({
        boxShadow: [undefined, shadows["shadow-card"]],
        marginTop: [0, rem("space-16")],
        padding: [rem("space-0"), rem("space-6")],
        borderRadius: [0, shapes["border-radius-3"]],
      }),
      {
        background: colors["surface-overlay"],
        padding: `${rem("space-7")} ${rem("space-6")} ${rem("space-7")} ${rem(
          "space-6"
        )}`,
        display: "flex",
        textAlign: "center",
        flexDirection: "column",
        gap: `${rem("space-4")}}`,
      }
    ),
  };
}
